import { useQuery } from '@tanstack/react-query';
import _merge from 'lodash/merge';

import { getAccountTrades } from '@arrived/api_v2';
import { AccountId, TradesQueryFilters, OfferingTransaction } from '@arrived/models';

import { UseQueryResult, UseQueryOptions, MAX_STALE_TIME } from '../queries.utils';
import { accountTradesQueryKeyFn } from './trades.keys';

const defaultFilters = {
  size: 1000,
};

export function useAccountTradesQuery(
  accountId?: AccountId,
  filters?: TradesQueryFilters,
  options?: UseQueryOptions<OfferingTransaction[]>
): UseQueryResult<OfferingTransaction[]> {
  const passedFilters = _merge({}, defaultFilters, filters);

  return useQuery(
    accountTradesQueryKeyFn(accountId!, passedFilters),
    () => (accountId ? getAccountTrades(accountId, passedFilters) : Promise.resolve([])),
    {
      ...options,
      staleTime: options?.staleTime ?? MAX_STALE_TIME,
      enabled: (options?.enabled ?? true) && Boolean(accountId),
    }
  );
}
